<template>

    <div class="etre-agir-box">
        <div class="etre">
            <span class="rotate"><span class="first">notre<br> raison<br> d'</span> <span>être</span></span>
            <span class="invisible">être</span>
            <div class="etre-content">
                <h2>Notre<br>
                    raison<br>
                    d’être
                </h2>
                <a href="/etre" @click.prevent="toEtre()" class="etre-button">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.49 22.14">
                        <path d="M21.2.33A1.11,1.11,0,0,0,19.62,1.9l8.05,8H1.11A1.1,1.1,0,0,0,0,11.06a1.12,1.12,0,0,0,1.11,1.13H27.67l-8,8a1.14,1.14,0,0,0,0,1.59,1.11,1.11,0,0,0,1.58,0l10-9.95a1.1,1.1,0,0,0,0-1.57Z"/>
                    </svg>
                </a>
                <p>
                    Nous avons posé notre raison d'être :<br>
                    nous sommes là pour permettre<br>
                    au plus grand nombre de construire<br>
                    leur vie en confiance.
                </p>
            </div>
        </div>
        <div class="agir">
            <span class="rotate"><span class="first">nos<br> raisons<br> d'</span> <span>agir</span></span>
            <span class="invisible">agir</span>
            <div class="agir-content">
                <p>
                    Notre raison d'être nous réunit, nous<br>
                    inspire et nous engage à incarner un<br>
                    mutualisme d'actions au service de nos<br>
                    parties prenantes. Elles sont nos<br>
                    raisons d'agir.
                </p>
                <h2>
                    nos<br>
                    raisons<br>
                    d’agir</h2>
                <a href="/agir" @click.prevent="toAgir()" class="agir-button">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.49 22.14">
                        <path d="M10.28,21.81a1.12,1.12,0,1,0,1.59-1.57l-8-8H30.38a1.1,1.1,0,0,0,1.11-1.11A1.12,1.12,0,0,0,30.38,10H3.82l8-8a1.14,1.14,0,0,0,0-1.59,1.12,1.12,0,0,0-1.59,0l-9.95,10a1.11,1.11,0,0,0,0,1.58Z"/>
                    </svg>
                </a>
            </div>
            <div class="mobile-content">
                <p>
                    Nous avons posé notre raison d'être :<br>
                    nous sommes là pour permettre<br>
                    au plus grand nombre de construire<br>
                    leur vie en confiance.
                </p>
                <p>
                    Notre raison d'être nous réunit, nous<br>
                    inspire et nous engage à incarner un<br>
                    mutualisme d'actions au service de nos<br>
                    parties prenantes. Elles sont nos<br>
                    raisons d'agir.
                </p>
            </div>
        </div>
    </div>

</template>

<script>

    import anime from 'animejs';

    export default {
        name: "EtreAgir",
        mounted() {
            switch (this.$route.name) {
                case 'Home':
                    this.initHomepage();
                    break;
                case 'Agir':
                    this.initAgir();
                    break;
                case 'Etre':
                    this.initEtre();
                    break;
            }
        },
        watch: {
            '$route.name'() {
                if (this.$route.name === 'Home')
                    this.toHomepage();
            }
        },
        methods: {
            initHomepage() {
                let timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    duration: 1000,
                });
                timeline
                    .add({
                        targets: document.querySelector('.etre'),
                        translateX: ['-35%', '-35%'],
                        translateY: ['-200%', '-50%'],
                    }, 0)
                    .add({
                        targets: document.querySelector('.agir'),
                        translateX: ['-65%', '-65%'],
                        translateY: ['200%', '-20%'],
                    }, 0)
                    .add({
                        targets: document.querySelector('.etre h2'),
                        opacity: [0, 1],
                    }, 1000)
                    .add({
                        targets: document.querySelector('.etre p'),
                        opacity: [0, 1],
                    }, 1500)
                    .add({
                        targets: document.querySelector('.etre a'),
                        opacity: [0, 1],
                    }, 2000)
                    .add({
                        targets: document.querySelector('.agir h2'),
                        opacity: [0, 1],
                    }, 1000)
                    .add({
                        targets: document.querySelector('.agir p'),
                        opacity: [0, 1],
                    }, 1500)
                    .add({
                        targets: document.querySelector('.agir a'),
                        opacity: [0, 1],
                    }, 2000)
                    .add({
                        targets: document.querySelector('.mobile-content'),
                        opacity: [0, 1],
                    }, 2500)
            },
            toHomepage() {
                let timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    duration: 1000,
                });

                timeline
                    .add({
                        targets: document.querySelector('.agir span.rotate'),
                        rotate: 90,
                        translateX: '0%',
                        translateY: '-50%',
                    }, 0)
                    .add({
                        targets: document.querySelector('.etre span.rotate'),
                        rotate: -90,
                        translateY: '-50%',
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.etre span span.first, .agir span span.first'),
                        opacity: 0,
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.etre, .agir h2, .agir a, .agir p'),
                        opacity: 1,
                    }, 1000)
                    .add({
                        targets: document.querySelectorAll('.agir, .etre h2, .etre a, .etre p'),
                        opacity: 1,
                    }, 1000)


            },
            initAgir() {
                let timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    duration: 1000,
                });

                timeline
                    .add({
                        targets: document.querySelectorAll('.etre, .agir h2, .agir a, .agir p'),
                        opacity: [0, 0],
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.agir span span'),
                        opacity: [1, 1],
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.agir span.rotate'),
                        rotate: [0, 0],
                        translateX: ['40%', '40%'],
                        translateY: ['-80%', '-80%'],
                    }, 0)
            },
            initEtre() {
                let timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    duration: 1000,
                });

                timeline
                    .add({
                        targets: document.querySelectorAll('.agir, .etre h2, .etre a, .etre p'),
                        opacity: [0, 0],
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.etre span span'),
                        opacity: [1, 1],
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.etre .rotate'),
                        rotate: 0,
                        translateY: ['-50%', '-50%'],
                    }, 0)
            },
            toEtre() {
                let timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    duration: 1000,
                })

                timeline
                    .add({
                        targets: document.querySelector('.etre span.rotate'),
                        rotate: [-90, 0],
                        translateY: ['-50%', '-50%'],
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.agir, .etre h2, .etre a, .etre p'),
                        opacity: 0,
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.etre span span'),
                        opacity: 1,
                        complete: () => {
                            setTimeout(() => {
                                this.$router.replace('/etre');
                            }, 300)
                        }
                    }, 0)
            },
            toAgir() {
                let timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    duration: 1000,
                })

                timeline
                    .add({
                        targets: document.querySelector('.agir span.rotate'),
                        rotate: [90, 0],
                        translateX: ['0%', '40%'],
                        translateY: ['-50%', '-80%'],
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.etre, .agir h2, .agir a, .agir p'),
                        opacity: 0,
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.agir span span'),
                        opacity: 1,
                        complete: () => {
                            setTimeout(() => {
                                this.$router.replace('/agir');
                            }, 300)
                        }
                    }, 0)
            },
            fromEtreToAgir() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'auto'
                });

                let timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    duration: 600,
                })

                timeline
                    .add({
                        targets: document.querySelector('.etre-menu'),
                        translateX: [0, '100%'],
                    })
                    .add({
                        targets: document.querySelector('.etre'),
                        opacity: [1, 0],
                        complete: () => {
                            this.$router.replace('/agir');
                        }
                    }, 600)
                    .add({
                        targets: document.querySelectorAll('.agir h2, .agir a, .agir p'),
                        opacity: [0, 0],
                    }, 600)
                    .add({
                        targets: document.querySelectorAll('.agir span span'),
                        opacity: 1,
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.agir span.rotate'),
                        rotate: [0, 0],
                        translateX: ['40%', '40%'],
                        translateY: ['-80%', '-80%'],
                    })
                    .add({
                        targets: document.querySelector('.agir'),
                        opacity: [0, 1],
                    })
            },
            fromAgirToEtre() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'auto'
                });

                let timeline = anime.timeline({
                    easing: 'easeInOutQuad',
                    duration: 600,
                })

                timeline
                    .add({
                        targets: document.querySelector('.etre-menu'),
                        translateX: [0, '-100%'],
                    })
                    .add({
                        targets: document.querySelector('.agir'),
                        opacity: [1, 0],
                        complete: () => {
                            this.$router.replace('/etre');
                        }
                    }, 600)
                    .add({
                        targets: document.querySelectorAll('.etre h2, .etre a, .etre p'),
                        opacity: [0, 0],
                    }, 600)
                    .add({
                        targets: document.querySelectorAll('.etre span span'),
                        opacity: 1,
                    }, 0)
                    .add({
                        targets: document.querySelectorAll('.etre span.rotate'),
                        rotate: [0, 0],
                        translateY: ['-50%', '-50%'],
                    })
                    .add({
                        targets: document.querySelector('.etre'),
                        opacity: [0, 1],
                    })
            }
        }
    }
</script>

<style lang="scss">

    .etre-agir-box {
    }

    .etre, .agir {
        z-index: 99;
        user-select: none;
        pointer-events: none;

        span {
            font-weight: 800;
            font-size: 200px;
            line-height: 285px;
            text-transform: uppercase;
        }

        span.invisible {
            opacity: 0;
            user-select: none;
            pointer-events: none;
            z-index: -1;
            position: relative;
        }

        &-content {
            position: absolute;
            display: flex;
            flex-direction: column;
            z-index: 9;

            p {
                color: white;
                font-size: 16px;
                margin-bottom: 30px;
                margin-top: 40px;
            }

            h2 {
                font-size: 35px;
                text-transform: uppercase;
                line-height: 1;
                margin-top: 0;
                margin-bottom: 10px;
            }
        }

        &-button {
            border-radius: 50%;
            border: 1px solid #00352c;
            width: 50px;
            height: 50px;
            text-decoration: none;
            text-indent: -9999px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #006b58;
            z-index: 9;
            position: relative;
            pointer-events: auto;

            svg {
                width: 50%;
                height: 50%;
            }

        }

    }

    .etre {
        color: #a1bf38;
        position: absolute;
        transform: translate(-35%, -50%);
        left: 50%;
        top: 50%;
        display: flex;

        span {
            position: relative;

            span {
                &:nth-child(1) {
                    opacity: 0;
                    line-height: 50px;
                    position: absolute;
                    font-size: 50px;
                    text-align: right;
                    transform: translate(-100%, 36%);
                    color: #00352c;
                }
            }

        }

        span.rotate {
            position: absolute;
            transform: rotate(-90deg) translateY(-50%);
        }

        &-content {
            text-align: right;
            top: 0;
            left: 0;
            transform: translate(-100%, -15%);
            text-transform: none;
        }

        &-button {
            align-self: flex-end;
            border-color: #a1bf38;

            svg {
                fill: #a1bf38;
            }

        }

        &-box {

        }
    }

    .agir {
        color: #00352c;
        position: absolute;
        transform: translate(-65%, -20%);
        left: 50%;
        top: 50%;

        span {
            position: relative;

            span {
                &:nth-child(1) {
                    opacity: 0;
                    line-height: 1;
                    position: absolute;
                    font-size: 50px;
                    text-align: right;
                    transform: translate(-100%, 36%);
                    color: #a1bf38;
                }
            }

        }


        span.rotate {
            position: absolute;
            transform: rotate(90deg) translateY(-50%);
        }

        &-content {
            bottom: 0;
            right: 0;
            transform: translate(100%, 25%);
            text-transform: none;
        }

        &-button {
            svg {
                fill: #00352c
            }

        }

        &-box {
        }
    }

    .mobile-content {
        display: none;
    }


    @media screen and (max-width: 1400px) {
        .etre span, .agir span {
            font-size: 150px;
            line-height: 205px;
        }

        .etre-content {
            transform: translate(-100%, -25%);
        }

        .etre span span:first-child, .agir span span:first-child {
            font-size: 36px;
            line-height: 36px;
        }
    }

    @media (orientation: portrait) and (max-width: 1025px) {
        .etre-content p, .agir-content p {
            display: none;
        }
        .etre, .agir {
            top: 32%;
        }
        .mobile-content {
            display: block;
            position: absolute;
            transform: translate(30%, 40%);
            color: white;
        }

        .page-etre, .page-agir {
            margin-top: 20vh !important;
        }
    }

    @media (orientation: portrait) and (max-width: 800px) {
        .page-etre, .page-agir {
            margin-top: 30vh !important;
        }
    }

    @media (orientation: portrait) and (max-width: 500px) {

        .etre, .agir {
            top: 24%;
        }

        .etre span, .agir span {
            font-size: 80px;
            line-height: 110px;
        }

        .etre-content h2, .agir-content h2 {
            font-size: 18px;
        }

        .mobile-content {
            transform: translate(-15%, 25%);
            width: 95vw;
            text-align: center;
        }

        .etre span span:first-child, .agir span span:first-child {
            font-size: 20px;
            line-height: 20px;
        }

        .page-etre, .page-agir {
            margin-top: 25vh !important;
        }
    }

    @media (orientation: portrait) and (max-width: 375px) {

        .etre, .agir {
            top: 32%;
        }

        .page-etre, .page-agir {
            margin-top: 35vh !important;
        }
    }

    @media (orientation: portrait) and (max-width: 320px) {

        .etre span, .agir span {
            font-size: 60px;
            line-height: 85px;
        }

        .etre, .agir {
            top: 32%;
        }

        .mobile-content {
            transform: translate(-20%, 20%);
            font-size: 14px;
        }

        .etre-content h2, .agir-content h2 {
            font-size: 14px;
        }

        .etre span span:first-child, .agir span span:first-child {
            font-size: 15px;
            line-height: 15px;
        }

        .page-etre, .page-agir {
            margin-top: 30vh !important;
        }

    }

</style>
